import { useState as l, useEffect as d } from "react";
import { i as f } from "../core-DVmjA3_O.js";
import { r as g } from "../string-CZdwCjMt.js";
import "../type-Dku6Xzl6.js";
import { getSpacingValue as m, getOpticallyCorrectedSpacingValue as $ } from "../utils/style.js";
function C(p) {
  const [n] = l(() => `spacing-token-${g()}`), {
    spacing: i = "md",
    modes: o = ["padding-inline", "padding-block"],
    offset: a = 0,
    withoutOpticalCorrection: s,
    withAdditionalInlinePadding: c
  } = p;
  return d(
    () => {
      if (f(i))
        return;
      const r = m(i, a), e = document.createElement("style");
      if (document.head.appendChild(e), !e.sheet) {
        e.remove();
        return;
      }
      const u = o.map((t) => t === "padding-inline" && c ? `${t}: calc(${r} * 1.5 + var(--go-ui-spacing-2xs))` : s ? `${t}: ${r}` : `${t}: ${$(r, t)}`).join("; ");
      return e.sheet.insertRule(`.${n} { ${u} }`), () => {
        e.remove();
      };
    },
    [i, o, n, a, s, c]
  ), n;
}
export {
  C as default
};
